import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home/Home';
import Events from './components/Events';
import EventDetail from './components/EventDetail';
import Registration from './components/Registration';
import Confirmation from './components/Confirmation';
import About from './components/About';     // ✅ Import
import Contact from './components/Contact'; // ✅ Import
import './App.css';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop.jsx';
import FloatingButtons from './components/FloatingButtons.jsx';
import PrivacyPolicy from './components/PrivacyPolicy.jsx';
import TermsOfService from './components/TermsOfService.jsx';
function App() {
  return (
    <div className="app">
      <ScrollToTop/>
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/register/:eventId" element={<Registration />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/about" element={<About />} />       
          <Route path="/contact" element={<Contact />} />  
          <Route path="/privacy" element={<PrivacyPolicy />} /> 
          <Route path="/terms" element={<TermsOfService />} /> 
        </Routes>
      </main>
      <Footer/>
      <FloatingButtons/>
    </div>
  );
}

export default App;